import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import MyFriendList from "./MyFriendList";
//import MyViewNew from './MyViewNew'
import { isMobile, isAndroid, isIOS } from "react-device-detect";

class MyFriend extends PureComponent {
  state = {
    index: this.props.childProps.index ? this.props.childProps.index : 0,
  };
  componentDidMount = () => {};
  _changeIndex = (index) => {
    const { _myMenu } = this.props.childProps;
    _myMenu(index);
  };
  friendAdd = () => {
    alert(0);
    const { showFriend } = this.props;

    showFriend(true);
  };
  render() {
    const { index } = this.props.childProps;
    return (
      <Fragment>
        <div className="my_con">
          <div className="my_tab">
            {isMobile ? null : (
              <h3>
                <a href="#" class="btn_back"></a>내 친구
              </h3>
            )}

            <ul>
              <li>
                <button
                  type="button"
                  className={index === 8 ? "active" : null}
                  onClick={() => this._changeIndex(8)}
                >
                  내 친구 현황
                </button>
              </li>
              {/*<li><button type="button" className={index === 9 ? "active" : null } onClick={()=>this.friendAdd}>친구 추천하기</button></li>*/}
            </ul>
          </div>

          {index === 8 ? <MyFriendList /> : null}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(MyFriend)));
